import Script from 'next/script'
import { reportError } from '@mc/next-newrelic'
import { useTurnstile } from '@mc/turnstile'

export const Turnstile = () => {
  if (useTurnstile() !== 'variant_1') {
    return null
  }
  return (
    <Script
      src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
      async
      defer
      onError={(e) => {
        // eslint-disable-next-line no-console
        console.error('Turnstile script onError', e)
        reportError(new Error('Turnstile script onError'), {
          errEvent: JSON.stringify(e),
        })
      }}
    />
  )
}
